import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import DetailsSidebar from '@/components/DetailsSidebar';
import Documents from './pizza_tracker_tabs/Documents';
import Details from './pizza_tracker_tabs/Details';

const PizzaTracker = ({
  isDrawerOpen,
  setIsDrawerOpen,
  selectedSubmission,
}: {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  selectedSubmission: {
    id: string;
    title: string;
    status: string;
    display_id: string;
    submission_type?: 'Study' | 'StudySite' | 'Submission';
    owner_id?: string;
  };
}) => {
  const navigate = useNavigate();

  const { footerLabel, footerPath } = useMemo(() => {
    if (
      selectedSubmission.submission_type === 'Study' &&
      selectedSubmission.owner_id
    ) {
      return {
        footerLabel: 'View Study',
        footerPath: `/studies/${selectedSubmission.owner_id}`,
      };
    }
    if (
      selectedSubmission.submission_type === 'StudySite' &&
      selectedSubmission.owner_id
    ) {
      return {
        footerLabel: 'View Site',
        footerPath: `/sites/${selectedSubmission.owner_id}`,
      };
    }
    return {
      footerLabel: 'View Submission',
      footerPath: `/submissions/${selectedSubmission.id}`,
    };
  }, [
    selectedSubmission.submission_type,
    selectedSubmission.owner_id,
    selectedSubmission.id,
  ]);

  const tabs = useMemo(
    () => [
      {
        id: 'details',
        label: 'Details',
        content: (
          <Details
            submissionId={selectedSubmission.id}
            status={selectedSubmission.status}
            submissionType={selectedSubmission.submission_type}
            ownerId={selectedSubmission.owner_id}
          />
        ),
      },
      {
        id: 'documents',
        label: 'Documents',
        content: <Documents submissionId={selectedSubmission.id} />,
      },
    ],
    [
      selectedSubmission.id,
      selectedSubmission.status,
      selectedSubmission.submission_type,
      selectedSubmission.owner_id,
    ]
  );

  return (
    <DetailsSidebar
      open={isDrawerOpen}
      onOpenChange={setIsDrawerOpen}
      displayId={selectedSubmission.display_id}
      tabs={tabs}
      defaultTab="details"
      footerLabel={footerLabel}
      onFooterClick={() => navigate(footerPath)}
    />
  );
};

export default PizzaTracker;
